import Icon from '~/src/common/components/Icon';
import { Tag } from '~/src/common/components/Tag/Tag';
import I18n from '~/src/common/services/I18n';

const DurationTag = ({ duration }: { duration: number }) => (
  <Tag>
    <Icon name="clock-normal" size={16} color="NEUTRAL_DEFAULT" />
    {I18n.t('recipe-screen.duration-time', { duration })}
  </Tag>
);

export default DurationTag;
